import { apiClient } from './client'
import type { NotificationDto, NotificationType } from './types'

export interface NotificationsResponse {
  items: NotificationDto[]
  unreadCount: number
  /** Непрочитанные в разрезе активного фильтра типа (= unreadCount без type). */
  unreadCountFiltered: number
  /** Типы, реально существующие у пользователя — для выпадашки фильтра. */
  availableTypes: NotificationType[]
  page: number
  limit: number
  total: number
}

export async function getNotifications(
  params: {
    page?: number
    limit?: number
    isRead?: boolean
    type?: NotificationType
  } = {},
): Promise<NotificationsResponse> {
  const res = await apiClient.get<{ success: true; data: NotificationsResponse }>(
    '/notifications',
    { params },
  )
  return res.data.data
}

export async function getUnreadNotificationsCount(): Promise<{ unreadCount: number }> {
  const res = await apiClient.get<{ success: true; data: { unreadCount: number } }>(
    '/notifications/unread-count',
  )
  return res.data.data
}

export async function markNotificationRead(id: string): Promise<NotificationDto> {
  const res = await apiClient.patch<{ success: true; data: NotificationDto }>(
    `/notifications/${id}/read`,
  )
  return res.data.data
}

export async function markAllNotificationsRead(
  // С type — «прочитать все» применяется только к выбранному типу (03.08).
  type?: NotificationType,
): Promise<{ unreadCount: number }> {
  const res = await apiClient.patch<{ success: true; data: { unreadCount: number } }>(
    '/notifications/read-all',
    type ? { type } : {},
  )
  return res.data.data
}

export async function deleteNotification(id: string): Promise<void> {
  await apiClient.delete(`/notifications/${id}`)
}
